import { createSlice } from "@reduxjs/toolkit";

import { factory } from "../../api/apiFactory";
import dayjs from "dayjs";
const reportsApi = factory.get("reports");

const initialState = {
  data: [],
  total: 0,
  loading: false,
  dialog: {
    loading: false,
    open: false,
    data: [],
    report_name: "",
    total: 0,
  },
};

const reportsSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = !state.loading;
    },
    setLoadingMoreDetails: (state) => {
      state.dialog.loading = !state.dialog.loading;
    },
    setReports: (state, action) => {
      state.data = action.payload.data;
      state.total = action.payload.total;
    },
    clearReports: (state) => {
      state.data = [];
      state.total = 0;
    },
    setDialog: (state, { payload }) => {
      state.dialog.open = payload.open;
      state.dialog.report_name = payload.report_name || "";
      if (!payload.open) {
        state.dialog.data = [];
        state.dialog.total = 0;
      }
    },
    setMoreDetails: (state, { payload }) => {
      state.dialog.data = payload.data || [];
      state.dialog.total = payload.total || 0;
    },
  },
});

export const {
  setLoading,
  setReports,
  clearReports,
  setDialog,
  setMoreDetails,
  setLoadingMoreDetails,
} = reportsSlice.actions;

export default reportsSlice.reducer;

//

export const fetch = (reportName, params) => async (dispatch) => {
  try {
    dispatch(clearReports());
    dispatch(setLoading());
    const response = await reportsApi[reportName](params);
    dispatch(setReports(response.data));
    dispatch(setLoading());
  } catch (error) {
    dispatch(setLoading());
    // console.log(error);
  }
};

export const moreDetails = (reportName, params) => async (dispatch) => {
  try {
    dispatch(
      setDialog({
        open: true,
        report_name: reportName,
      })
    );
    dispatch(setLoadingMoreDetails());
    const response = await reportsApi[reportName](params);
    dispatch(setLoadingMoreDetails());
    dispatch(setMoreDetails(response.data));

    // dispatch(
    //   setDialog({
    //     open: true,
    //     data: response.data.data,
    //     total: response.data.total,
    //     report_name: reportName,
    //   })
    // );
  } catch (error) {
    // console.log(error);
  }
};

const employeeDailyReportXlsx = (params) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const res = await reportsApi.employeeDaily(params, {
      responseType: "blob",
    });
    let url = window.URL.createObjectURL(res.data);
    let a = document.createElement("a");
    a.href = url;
    a.download = `دوام-الموظف-${dayjs().format("YYYY_MM_DD_HH:mm")}.xlsx`;
    a.click();
    dispatch(setLoading());
  } catch (err) {
    dispatch(setLoading());
    throw new Error(err);
  }
};

export const Reports = {
  fetch,
  moreDetails,
  employeeDailyReportXlsx,
};
